import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { ImageboxOneComponent } from './imagebox-one.component'; 
import { GoogleplayBtnModule } from '@src/app/core/shared/components/ui/buttons/googleplay/button.module';
import { ApplestoreBtnModule } from '@src/app/core/shared/components/ui/buttons/applestore/button.module';

@NgModule({
  declarations: [ImageboxOneComponent],
  exports: [ImageboxOneComponent],
  imports: [
    CommonModule, GoogleplayBtnModule, ApplestoreBtnModule
  ]
})
export class ImageboxOneModule {}
